import gql from 'graphql-tag';

import type { ProjectSectionSummary } from 'src/data/project';
import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type { BackendMutationCreateProjectSectionArgs } from 'src/types/backend';

import { FRAGMENT_PROJECT_SECTION } from './schema';

const MUTATION = gql`
  mutation CreateProjectSection($projectId: ID!, $name: String) {
    createProjectSection(projectId: $projectId, name: $name) {
      ...ProjectSectionFields
    }
  }
  ${FRAGMENT_PROJECT_SECTION}
`;

export const createProjectSection = async (
  variables: BackendMutationCreateProjectSectionArgs
): Promise<ProjectSectionSummary | undefined> => {
  const response = await executeGqlMutation({ mutation: MUTATION, variables });
  return getSingleProp<ProjectSectionSummary>(response.data);
};
